import React, { useEffect, useState, useCallback } from "react";
import { QRCode } from 'react-qrcode-logo';
import { useSelector } from "react-redux";
import moment from "jalali-moment";
import { useNavigate } from 'react-router-dom'
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";

///import
import PageChange from "../../pageChange/index";
import { Logout } from "../../redux/featuer/user/userSlice";
import Layout from "../../component/Layout/Layout";
import toast from "react-hot-toast";


const Allqr = () => {

    const navigate = useNavigate()
    const [isDataLoad, setIsDataLoad] = useState(false);
    const [data, setData] = useState([])
    const [paginationSelected, setPaginationSelected] = useState(1);
    const [loadPage, setLoadPage] = useState(0)
    const { token, login, user } = useSelector((item) => item.user)
    const dispatch = useDispatch()
    const qrSize = 1024;
    var { t } = useTranslation()

    var limitPage = 8;
    var pagination = 1;

    const getOrder = useCallback(async (limit, page) => {
        try {
            const response = await fetch(`${process.env.REACT_APP_SERVER}/api/nft/all/${limit}/${page}`, {
                method: "GET",
                headers: {
                    Authorization: "ArNew " + token,
                },
            });

            const result = await response.json();
            if (!result.data) {
                dispatch(Logout());
                toast.error("شما دسترسی ندارید");
                window.location.href = 'login';
                return;
            }

            if (result.status === "success") {
                setLoadPage(parseInt(result.pages));
                setData(result.data);
                setIsDataLoad(true);
            } else {
                toast.error(result.msg);
                dispatch(Logout());
                window.location.href = '/login';
            }
        } catch (error) {
            console.log(error);
        }
    }, [dispatch, setData, setIsDataLoad, setLoadPage, token]);

    useEffect(() => {
        document.title = "کیو ار کد "
        if (login === true) {
            getOrder(limitPage, pagination);
        } else {
            window.location.href = '/'
        }
    }, [getOrder, limitPage, login, pagination])

    //preview table page button
    function actionPreviewPagination() {
        setIsDataLoad(false);
        getOrder(limitPage, paginationSelected - 1);
        setPaginationSelected(paginationSelected - 1);
    }

    //next table page button
    function actionNextPagination() {
        setIsDataLoad(false);
        getOrder(limitPage, paginationSelected + 1);
        setPaginationSelected(paginationSelected + 1);
    }





    const downloadQRCode = () => {
        const canvas = document.getElementById("QR");
        if (canvas) {
            const pngUrl = canvas
                .toDataURL("image/png")
                .replace("image/png", "image/octet-stream");
            let downloadLink = document.createElement("a");
            downloadLink.href = pngUrl;
            downloadLink.download = `qr.png`;
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
        }
    };


    const copyText = (userName, url) => {
        window.navigator.clipboard.writeText(`${process.env.REACT_APP_CLIENT}/view/${userName}/${url}`)
        toast.success(t("link_was_copied"))
    }

    return (
        <>
            <>
                {isDataLoad ? (
                    <>
                        <Layout >
                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 ">
                                {data.map((item, index) => {
                                    // const userName = user.username;
                                    var userName = item.user.username;
                                    var url = item.url;
                                    const qrUrl = `${process.env.REACT_APP_CLIENT}/view/${userName}/${url}`;
                                    const logoImage = item.types === 0 ? user.logo ? `${process.env.REACT_APP_SERVER}${user.logo}` : "/public/logo.png" : "/public/logo.png";
                                    const formattedDate = moment(new Date(parseInt(item.create_in))).format("jYYYY/jMM/jDD");
                                    return (
                                        <div className="mt-12 bg-white border border-gray-200 rounded-lg shadow-md cursor-pointer w-80 justify-self-center " key={index}>
                                            {/* qrcode  */}
                                            <div className="relative flex justify-center w-full "
                                            >
                                                <div className="blur-[3px] hover:blur-sm canvas-qr">
                                                    <QRCode
                                                        value={qrUrl}
                                                        size={qrSize}
                                                        logoImage={logoImage}
                                                        fgColor="#000"
                                                        removeQrCodeBehindLogo={false}
                                                        quietZone={5}
                                                        eyeRadius={[
                                                            { outer: [10, 10, 0, 10], inner: [0, 10, 10, 10] },
                                                            [10, 10, 10, 0],
                                                            [10, 0, 10, 10],
                                                        ]}
                                                        enableCORS={true}
                                                        logoWidth={qrSize / 2}
                                                        logoHeight={qrSize / 2}
                                                        logoOpacity={0.4}
                                                        ecLevel="Q"
                                                        qrStyle={"dots"}
                                                        id="QR"
                                                    />
                                                </div>
                                                <div className="absolute gap-2 mt-20 " >
                                                    <button onClick={() => copyText(userName, url)} className="w-full px-2 py-2 text-sm font-medium text-center text-white bg-blue-600 rounded-lg hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">{t("copy")}</button>
                                                    <hr className="mt-3 bg-black" />
                                                    <button onClick={() => downloadQRCode()} className="w-full px-2 py-2 mt-3 text-sm font-medium text-center text-white bg-blue-600 rounded-lg hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">{t("download")}</button>
                                                </div>
                                            </div>
                                            {/* date & view  */}
                                            <div className="p-5 "
                                                onClick={() => navigate(`/qrcode/${item._id}`)}
                                            >
                                                <div className="flex items-center justify-center w-full gap-10 pb-5 text-sm font-medium">
                                                    <div className="flex flex-col gap-3" id='wrapper'>
                                                        <p>{t("names")}:</p>
                                                        <p>{t("dates")}:</p>
                                                        <p> {t("visit")}:</p>
                                                    </div>
                                                    <div className="flex flex-col gap-3 text-sm font-medium ">
                                                        <span>{item.name}</span>
                                                        <span>{formattedDate}</span>
                                                        <span>{item.view}</span>

                                                    </div>
                                                </div>

                                            </div>

                                        </div>
                                    )
                                })}
                            </div>



                            {/* pagination  */}
                            <div className="flex items-center justify-center mt-10 mb-5">
                                <ul className="flex items-center h-16 gap-5 bg-white border px-14 " >
                                    {/* right */}
                                    <li>
                                        {paginationSelected < loadPage ? (
                                            <>
                                                <div
                                                    onClick={actionNextPagination}
                                                    className="px-2 py-1 bg-white border border-gray-300 cursor-pointer rounded-r-2xl"
                                                >
                                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6 text-gray-600">
                                                        <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
                                                    </svg>

                                                </div>
                                            </>

                                        ) :
                                            (
                                                <>
                                                    <div
                                                        className="px-3 py-1 bg-white border border-gray-300 rounded-r-2xl "
                                                    >
                                                        <p className="text-gray-600 ">...</p>
                                                    </div>
                                                </>
                                            )
                                        }
                                    </li>
                                    {/* center  */}
                                    <li>
                                        <div
                                            className="z-10 px-3 py-2 text-gray-600 border border-gray-300 rounded "
                                        >
                                            {paginationSelected}
                                        </div>
                                    </li>
                                    {/* left  */}
                                    <li>

                                        {paginationSelected === 1 ? (
                                            <>
                                                <div

                                                    className="px-3 py-1 bg-white border border-gray-300 rounded-l-2xl "
                                                >
                                                    <p className="text-gray-600 ">...</p>

                                                </div>
                                            </>
                                        ) :
                                            (
                                                <>
                                                    <li
                                                        onClick={actionPreviewPagination}
                                                        className="cursor-pointer"
                                                    >
                                                        <div
                                                            className="px-2 py-1 bg-white border border-gray-300 rounded-l-2xl "
                                                        >
                                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6 text-gray-600 ">
                                                                <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
                                                            </svg>
                                                        </div>

                                                    </li>
                                                </>
                                            )}
                                    </li>
                                </ul>
                            </div>
                            {/* end of pagination  */}
                            {/* modal */}

                        </Layout>
                    </>
                ) : (
                    <PageChange />
                )}
            </>

        </>
    )
}

export default Allqr;